// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.statistics__container {
  padding: 16px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
@media screen and (min-width: 1025px) {
  .statistics__container {
    padding: 32px;
  }
}
.statistics__title {
  font-family: "Jost", sans-serif;
  font-size: 31px;
  font-weight: 700;
  line-height: 34px;
  text-transform: uppercase;
}
.statistics__subtitle {
  font-family: "Jost", sans-serif;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.01em;
  margin-top: 28px;
}
.statistics__subtitle a {
  color: inherit;
  position: relative;
  outline: 0;
}
.statistics__subtitle a::after {
  content: "";
  position: absolute;
  bottom: 2px;
  left: 0;
  width: 100%;
  height: 1px;
  display: block;
  background-color: #0f0f0f;
  transition: width 0.35s;
}
@media screen and (min-width: 1025px) {
  .statistics__subtitle a::after {
    width: 0;
  }
  .statistics__subtitle a:focus-visible::after {
    width: 100%;
  }
}
@media (hover: hover) {
  .statistics__subtitle a::after {
    width: 0;
  }
  .statistics__subtitle a:hover::after {
    width: 100%;
  }
}
.statistics .load-data-button {
  border: 1px solid #000;
  border-radius: 0.25rem;
}
.statistics .load-data-button:hover {
  background-color: #000;
  color: #fff;
}
.statistics .load-data-button:disabled {
  background-color: gray;
  border-color: gray;
  color: #fff;
}
.statistics .country-picker {
  padding: 2px 0 8px;
  height: 35px;
}
.statistics__content {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/common.scss","webpack://./src/routes/Statistics/Statistics.scss"],"names":[],"mappings":"AA0CA;EACE;IACE,uBAAA;ECzCF;ED2CA;IACE,yBAAA;ECzCF;AACF;AAJE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAMJ;AAJI;EANF;IAOI,aAAA;EAOJ;AACF;AAJE;EACE,+BDdW;ECeX,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAMJ;AAHE;EACE,+BDtBW;ECuBX,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAKJ;AAHI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AAKN;AAHM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,yBDrCQ;ECsCR,uBAAA;AAKR;AAFM;EACE;IACE,QAAA;EAIR;EAFM;IACE,WAAA;EAIR;AACF;AADM;EACE;IACE,QAAA;EAGR;EAAM;IACE,WAAA;EAER;AACF;AAEE;EACE,sBAAA;EACA,sBAAA;AAAJ;AACI;EACE,sBAAA;EACA,WAAA;AACN;AACI;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;AACN;AAEE;EACE,kBAAA;EACA,YAAA;AAAJ;AAEE;EACE,YAAA;AAAJ","sourcesContent":["// Fonts\n$font-primary: 'Jost', sans-serif;\n$font-secondary: 'Jost', sans-serif;\n\n// Colors\n$color-primary: #0f0f0f;\n$color-secondary: #ffffff;\n$light-gray: #f0f0f0;\n$gray: #bdbdbd;\n$medium-gray: #8c8c8c;\n$dark-gray: #545454;\n$color-alert: #ed4848;\n\n// Placeholders\n%body-s {\n  font-family: $font-secondary;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.04em;\n}\n\n%body-m {\n  font-family: $font-secondary;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.01em;\n}\n\n%body-l {\n  font-family: $font-secondary;\n  font-size: 18px;\n  line-height: 26px;\n  letter-spacing: 0.01em;\n}\n\n// Animations\n$speed-smooth: 1s;\n$speed-slow: 0.65s;\n$speed-medium: 0.35s;\n$speed-fast: 0.25s;\n$speed-very-fast: 0.15s;\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@import \"../../common.scss\";\n\n.statistics {\n  &__container {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n\n    @media screen and (min-width: 1025px) {\n      padding: 32px;\n    }\n  }\n\n  &__title {\n    font-family: $font-primary;\n    font-size: 31px;\n    font-weight: 700;\n    line-height: 34px;\n    text-transform: uppercase;\n  }\n\n  &__subtitle {\n    font-family: $font-primary;\n    font-size: 18px;\n    line-height: 27px;\n    letter-spacing: 0.01em;\n    margin-top: 28px;\n\n    a {\n      color: inherit;\n      position: relative;\n      outline: 0;\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: 2px;\n        left: 0;\n        width: 100%;\n        height: 1px;\n        display: block;\n        background-color: $color-primary;\n        transition: width $speed-medium;\n      }\n\n      @media screen and (min-width: 1025px) {\n        &::after {\n          width: 0;\n        }\n        &:focus-visible::after {\n          width: 100%;\n        }\n      }\n\n      @media (hover: hover) {\n        &::after {\n          width: 0;\n        }\n\n        &:hover::after {\n          width: 100%;\n        }\n      }\n    }\n  }\n  .load-data-button {\n    border: 1px solid #000;\n    border-radius: 0.25rem;\n    &:hover {\n      background-color: #000;\n      color: #fff;\n    }\n    &:disabled {\n      background-color: gray;\n      border-color: gray;\n      color: #fff;\n    }\n  }\n  .country-picker {\n    padding: 2px 0 8px;\n    height: 35px;\n  }\n  &__content {\n    flex-grow: 1;\n  }\n  &__disclaimer {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
